// Hydrate near-viewport videos without changing their owners' playback controls.
(() => {
  if (window.cbxLazyMedia) return;
  const pending = new Set();
  const pauseObserver = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(({target, isIntersecting}) => { if (!isIntersecting) target.pause(); });
  }) : null;
  const load = video => {
    if (!video?.hasAttribute('data-cbx-lazy-media')) return;
    if (video.dataset.cbxLazyPoster) {
      video.poster = video.dataset.cbxLazyPoster;
      delete video.dataset.cbxLazyPoster;
    }
    [video, ...video.querySelectorAll('source')].forEach(node => {
      if (!node.dataset.cbxLazySrc) return;
      node.src = node.dataset.cbxLazySrc;
      delete node.dataset.cbxLazySrc;
    });
    video.preload = 'none';
    video.removeAttribute('data-cbx-lazy-media');
    video.dataset.cbxMediaLoaded = 'true';
    pauseObserver?.observe(video);
    pending.delete(video);
    observer?.unobserve(video);
    video.load();
  };
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(({target, isIntersecting}) => { if (isIntersecting) load(target); });
  }, {rootMargin:'400px 0px'}) : null;
  const mount = (root = document) => {
    root.querySelectorAll('video[data-cbx-lazy-media]').forEach(video => {
      if (pending.has(video)) return;
      pending.add(video);
      if (observer) observer.observe(video); else load(video);
    });
  };
  window.cbxLazyMedia = {load};
  // Capture before existing play buttons, including quick jumps to lower sections.
  ['pointerdown', 'click', 'keydown'].forEach(type => document.addEventListener(type, event => {
    if (type === 'keydown' && !['Enter', ' '].includes(event.key)) return;
    const owner = event.target.closest?.('video-media, .cbx-kit-discovery__media, article, [class*="ai-video-showcase__media-"]');
    owner?.querySelectorAll('video[data-cbx-lazy-media]').forEach(load);
  }, true));
  document.addEventListener('shopify:section:load', event => mount(event.target));
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) document.querySelectorAll('video[data-cbx-media-loaded]').forEach(video => video.pause());
  });
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('video[data-cbx-media-loaded]').forEach(video => pauseObserver?.unobserve(video));
    pending.forEach(video => {
      if (!event.target.contains(video)) return;
      observer?.unobserve(video);
      pending.delete(video);
    });
  });
  mount();
})();
